module.exports = __webpack_public_path__ + "img/check-icon.83fd3b3f.svg";